import { Fonts } from "../../realms/types/fonts.type"
import { Component } from "./component"
import { getFontFamily } from "../theme.fonts"
import { handleComponentError } from "../decorators/handleComponentError"
import { TextComponent } from "../types/textComponent.interface"

export class Text extends Component<TextComponent> {
    override setHeight(height?: string): void {
        if (height) {
            this.element!.style.setProperty("font-size", height)
        }
    }

    protected setText(text?: string) {
        if (text) {
            ;(this.element as HTMLParagraphElement).textContent = text
        }
    }

    private async setFontFamily(customFont?: Fonts) {
        if (customFont) {
            const fontFamily = await getFontFamily(customFont)

            if (fontFamily) {
                const style = document.createElement("style")
                style.innerHTML = `*{
                    font-family: ${fontFamily} !important
                }`
                this.element?.shadowRoot?.append(style)
            }
        }
    }

    protected setColor(color?: string) {
        if (!color) return

        if (this.element?.shadowRoot) {
            const style = document.createElement("style")
            style.textContent = `
                * {
                    color: ${color} !important;
                    margin: 0 !important;
                }
            `
            this.element.shadowRoot.appendChild(style)
            return
        }

        this.element!.style.color = color
    }

    protected setHoverColor(hoverColor?: string) {
        if (!hoverColor) return

        if (this.element?.shadowRoot) {
            const style = document.createElement("style")
            style.textContent = `
                *:hover {
                    color: ${hoverColor} !important;
                }
            `
            this.element.shadowRoot.appendChild(style)
            return
        }

        const color = this.element!.style.color || "inherit"

        this.element!.addEventListener("mouseenter", () => {
            this.element!.style.color = hoverColor
        })
        this.element!.addEventListener("mouseleave", () => {
            this.element!.style.color = color
        })
    }

    protected setTextTransform(textTransform?: string) {
        if (textTransform) {
            const style = document.createElement("style")
            style.innerHTML = `* { text-transform: ${textTransform} !important; }`
            this.element?.shadowRoot?.appendChild(style)
        }
    }

    protected setDecoration(decoration?: string) {
        if (decoration) {
            this.element?.style.setProperty("text-decoration", decoration)
        }
    }

    protected setFontSize(fontSize?: string) {
        if (fontSize) {
            const style = document.createElement("style")
            style.innerHTML = `* { font-size: ${fontSize} !important; }`
            this.element?.shadowRoot?.appendChild(style)
        }
    }

    @handleComponentError("Text")
    render() {
        this.show(!!this.props.isVisible)
        this.setColor(this.props.color)
        this.setHoverColor(this.props.hoverColor)
        this.setHeight(this.props.height)
        this.setText(this.props.title)
        this.setFontFamily(this.props.fontFamily)
        this.setTextTransform(this.props.textTransform)
        this.setDecoration(this.props.decoration)
        this.setFontSize(this.props.fontSize)

        super.render()
    }
}
